import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

export default function Progress({ active, labels }: { active: number; labels: string[] }) {
	const { t } = useTranslation();
	return (
		<Box display="flex" flexDirection="column" gap="8px">
			<Box display="flex" alignItems="baseline" justifyContent="space-between" gap="12px">
				<Typography variant="body2" fontWeight={600}>
					{labels[active]}
				</Typography>
				<Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
					{t('academyReworkings.stepProgress', { current: active + 1, total: labels.length })}
				</Typography>
			</Box>
			<Box
				role="progressbar"
				aria-label={labels[active]}
				aria-valuemin={1}
				aria-valuemax={labels.length}
				aria-valuenow={active + 1}
				display="flex"
				gap="6px"
			>
				{labels.map((label, index) => (
					<Box
						key={label}
						sx={{
							flex: 1,
							minWidth: 0,
							height: '4px',
							borderRadius: '4px',
							bgcolor: index <= active ? 'primary.main' : 'action.disabledBackground',
						}}
					/>
				))}
			</Box>
		</Box>
	);
}
